<template>
	<div class="log-schedule-update-component">
		<div class="log-schedule-update-component-table-ctrls mb-4">
			<div class="filter-table__input-wrap search-control">
				<input @keyup.enter="onSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск">
				<button @click="onSearch()" class="search-control__input-btn reset-btn">
					<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
					</svg>
				</button>
			</div>

			<filter-component :filters="filter" />

			<a style="margin-left: auto;" class="btn brn-primary-fit" @click="showExportModal">Экспорт</a>
		</div>

		<table class="service-table table align-middle">
			<thead>
				<tr>
					<th scope="col" v-for="(elem, index) in thead" :key="index">
						<div style="display: flex; gap: 4px; align-items: center; justify-content: center;" class="th-inner sortable asc">
							<span style="width: 95%;">{{ elem }}</span>
							<div class="dropdown">
								<svg v-if="!['Описание статуса', 'Название расписания'].includes(elem)" @click="toggleDropdown(index)"
									style="cursor: pointer;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M5 7.5L10 12.5L15 7.5" stroke="#575F6E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<div class="dropdown-menu" :class="{ 'show': dropdownVisible[index] }">
									<a class="dropdown-item" href="#" @click.prevent="sortBy('asc', elem)">По возрастанию</a>
									<a class="dropdown-item" href="#" @click.prevent="sortBy('desc', elem)">По убыванию</a>
								</div>
							</div>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="row in tbody" :key="row.id">
					<td>
						<div class="marker marker_16px"
							:style="{ backgroundColor: row.status === 'offline' ? '#E33535' : '#23BA1F' }">
						</div>
					</td>
					<td>
						<div class="date-time-col">
							<span>{{ row.date }}</span>
							<span>{{ row.time }}</span>
						</div>
					</td>
					<td>{{ row.client }}</td>
					<td>{{ row.brand }}</td>
					<td>{{ row.pharm_number }}</td>
					<td>{{ row.device_type }}</td>
					<td>{{ row.ip }}</td>
					<td>{{ row.software }}</td>
					<td>{{ row.status_description }}</td>
					<td>{{ row.schedule_name }}</td>
				</tr>
			</tbody>
		</table>
	</div>

	<Transition name="fade">
        <ExportModal v-if="exportModal" :filters="filter" />
    </Transition>
</template>

<script>
import ExportModal from '../../../../modals/ExportModal.vue';
import { mapState, mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'LogHardwareComponent',

	components: { ExportModal },

	data() {
		return {
			thead: ['', 'Дата и время', 'Клиент', 'Бренд', 'Номер аптеки', 'Тип устройства', 'IP', 'ПО', 'Описание статуса', 'Название расписания'],
			tbody: [
				{
					id: 1, status: 'offline', date: '12.09.2024', time: '14:59', client: 'Неофарм', brand: 'Неофарм', pharm_number: '77-105', device_type: 'ИК', ip: '12.90.9.87', software: 'Windows', status_description: 'XXXX', schedule_name: 'XXXX'
				},
				{
					id: 2, status: 'online', date: '12.09.2024', time: '14:59', client: 'Неофарм', brand: 'Неофарм', pharm_number: '77-105', device_type: 'ИК', ip: '12.90.9.87', software: 'Windows', status_description: 'XXXX', schedule_name: 'XXXX'
				},
				{
					id: 3, status: 'online', date: '12.09.2024', time: '14:59', client: 'Неофарм', brand: 'Неофарм', pharm_number: '77-105', device_type: 'ИК', ip: '12.90.9.87', software: 'Windows', status_description: 'XXXX', schedule_name: 'XXXX'
				},
				{
					id: 4, status: 'online', date: '12.09.2024', time: '14:59', client: 'Неофарм', brand: 'Неофарм', pharm_number: '77-105', device_type: 'ИК', ip: '12.90.9.87', software: 'Windows', status_description: 'XXXX', schedule_name: 'XXXX'
				},
				{
					id: 5, status: 'offline', date: '12.09.2024', time: '14:59', client: 'Неофарм', brand: 'Неофарм', pharm_number: '77-105', device_type: 'ИК', ip: '12.90.9.87', software: 'Windows', status_description: 'XXXX', schedule_name: 'XXXX'
				},
				{
					id: 6, status: 'offline', date: '12.09.2024', time: '14:59', client: 'Неофарм', brand: 'Неофарм', pharm_number: '77-105', device_type: 'ИК', ip: '12.90.9.87', software: 'Windows', status_description: 'XXXX', schedule_name: 'XXXX'
				},
				{
					id: 7, status: 'online', date: '12.09.2024', time: '14:59', client: 'Неофарм', brand: 'Неофарм', pharm_number: '77-105', device_type: 'ИК', ip: '12.90.9.87', software: 'Windows', status_description: 'XXXX', schedule_name: 'XXXX'
				},
				{
					id: 8, status: 'offline', date: '12.09.2024', time: '14:59', client: 'Неофарм', brand: 'Неофарм', pharm_number: '77-105', device_type: 'ИК', ip: '12.90.9.87', software: 'Windows', status_description: 'XXXX', schedule_name: 'XXXX'
				},
				{
					id: 9, status: 'online', date: '12.09.2024', time: '14:59', client: 'Неофарм', brand: 'Неофарм', pharm_number: '77-105', device_type: 'ИК', ip: '12.90.9.87', software: 'Windows', status_description: 'XXXX', schedule_name: 'XXXX'
				},
				{
					id: 10, status: 'offline', date: '12.09.2024', time: '14:59', client: 'Неофарм', brand: 'Неофарм', pharm_number: '77-105', device_type: 'ИК', ip: '12.90.9.87', software: 'Windows', status_description: 'XXXX', schedule_name: 'XXXX'
				},
			],

			currentSortColumn: '',
			currentSortOrder: '',
			dropdownVisible: Array(10).fill(false),

			selectedRows: [],
			selectAll: false
		}
	},

	computed: {
		...mapState('filterComponent', ['filterState']),
		...mapState('logs', ['exportModal']),

		filter() {
			return [
				{
					type: 'select',
					name: 'Бренд',
					key: 'brand',
					model: null,
					options: ['Бренд 1', 'Бренд 2', 'Бренд 3']
				},
				{
					type: 'select',
					name: 'Клиент',
					key: 'client',
					model: null,
					options: ['Клиент 1', 'Клиент 2', 'Клиент 3']
				},
				{
					type: 'select',
					name: 'Тип устройства',
					key: 'device_type',
					model: null,
					options: ['Тип устройства 1', 'Тип устройства 2', 'Тип устройства 3']
				},
				{
					type: 'select',
					name: 'Статус',
					key: 'status',
					model: null,
					options: ['Статус 1', 'Статус 2', 'Статус 3']
				},
				{
					type: 'date',
					name: 'Дата',
					key: 'date',
					model: null
				},
			]
		}
	},

	methods: {
		...mapMutations('filterComponent', ['clearFilterState']),
		...mapMutations('logs', ['showExportModal']),

		sortBy(order, column) {
			this.currentSortColumn = this.columnMap[column];
			this.currentSortOrder = order;
			this.loadTable();
		},

		toggleDropdown: function (index) {
            setTimeout(() => {
                this.dropdownVisible = this.dropdownVisible.map((visible, i) => (i === index ? !visible : false));
            }, 1)
        },

        closeDropdown(event) {
            let clickOutside = event.target.className !== 'dropdown-item';
            let dropDownOpenned = document.querySelector('.show') !== null;
            if (dropDownOpenned && clickOutside) {
                this.dropdownVisible = this.dropdownVisible.map(() => false);
            };
        },

		toggleSelectAll() {
			if (this.selectAll) {
				this.selectedRows = this.tbody.map(row => row.id);
			} else {
				this.selectedRows = [];
			}
		},
	},

	watch: {
		selectedRows(newSelectedRows) {
			this.selectAll = newSelectedRows.length === this.tbody.length;
		}
	},

	mounted() {
		document.addEventListener('click', this.closeDropdown);
		this.clearFilterState();
	}
}
</script>

<style scoped lang="scss">
	.title-block {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
	}

	.page-label {
		font-size: 18px;
		font-weight: 600;
	}

	.date-time-col {
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.log-schedule-update-component-table-ctrls {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 20px;
	}

	.v-selects {
		display: flex;
		flex-direction: row;
		gap: 20px;
	}

	.dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-item {
        font-size: 14px;
    }

    .dropdown-menu {
        padding: 0;
        position: absolute;
        min-width: 160px;
        border-radius: 5px;
        border: none;
        box-shadow: 0px 4px 16px 0px rgba(100, 100, 100, 0.2);
        z-index: 1;
    }

    .dropdown-menu a {
        color: black;
        padding: 8px 12px;
        text-decoration: none;
        display: block;
    }

    .dropdown-menu a:hover {
        background-color: #F1F7FF;
    }
</style>
